import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import PartnerSidebar from './PartnerSidebar';
import PartnerNavbar from './PartnerNavbar';
import { useUser } from '../../context/UserContext';
import '../../pages/partner/partner.css';

const PartnerLayout = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, loading } = useUser();

  // Authentication & Authorization check
  useEffect(() => {
    if (loading) return;
    
    if (!isAuthenticated) {
      navigate('/account');
    } else if (user?.role !== 'partner') {
      navigate('/');
    }
  }, [isAuthenticated, user, loading, navigate]);

  // CSS wrapper for scoping
  useEffect(() => {
    document.body.classList.add('partner-mode');
    return () => document.body.classList.remove('partner-mode');
  }, []);

  if (loading) {
     return (
        <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '100vh' }}>
            <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
     );
  }

  if (!isAuthenticated || user?.role !== 'partner') {
    return null; // Will redirect
  }

  return (
    <div className="partner-layout">
      <PartnerSidebar />
      <div className="partner-main bg-light">
        <PartnerNavbar />
        <main className="partner-content-wrapper">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PartnerLayout;
